import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Hot from "@/pages/hot/page";
import Topics from "@/pages/topics/page";
import ArticleDetail from "@/pages/article/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "hot", element: <Hot /> },
      { path: "topics", element: <Topics /> },
      { path: "article/:id", element: <ArticleDetail /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;